import { gql, TypedDocumentNode } from '@common/hooks';
import {
  OrganizationUnitsQueryCgResponse,
  OrganizationUnitsQueryVariables,
  SelectOrganizationUnitsQueryCgResponse,
  SelectOrganizationUnitsQueryVariables,
  WorksOrganizationUnitsFlatQueryCgResponse,
  WorksOrganizationUnitsFlatQueryVariables,
  WorksOrganizationUnitsQueryCgResponse,
  WorksOrganizationUnitsQueryVariables,
} from '@common/graphql';

export type OrganizationUnitType =
  OrganizationUnitsQueryCgResponse['organizationUnits'][number];

export type OrganizationBusinessType =
  OrganizationUnitsQueryCgResponse['organizationUnits'][number]['department']['organizationBusiness'];

export const ORGANIZATION_UNITS_QUERY: TypedDocumentNode<
  OrganizationUnitsQueryCgResponse,
  OrganizationUnitsQueryVariables
> = gql`
  query OrganizationUnits($input: OrganizationUnitsInput) {
    organizationUnits(input: $input) {
      id
      name
      costCenter
      visible
      updatedAt
      department {
        id
        organizationBusiness {
          id
          name
          organizationUnitsActiveCount
        }
      }
      canUpdateSupplierDepartment {
        value
      }
      clinicalUnit {
        id
        displayName
      }
    }
  }
`;

export const ORGANIZATION_UNITS_FLAT_QUERY: TypedDocumentNode<
  WorksOrganizationUnitsFlatQueryCgResponse,
  WorksOrganizationUnitsFlatQueryVariables
> = gql`
  query WorksOrganizationUnitsFlat {
    organizationUnits {
      id
      name
    }
  }
`;

export const SELECT_ORGANIZATION_UNIT_QUERY: TypedDocumentNode<
  SelectOrganizationUnitsQueryCgResponse,
  SelectOrganizationUnitsQueryVariables
> = gql`
  query SelectOrganizationUnits($input: OrganizationUnitsInput) {
    organizationUnits(input: $input) {
      id
      name
      organizationBusiness {
        id
        name
      }
      costCenter
    }
  }
`;

export type SelectOrganizationUnitType =
  SelectOrganizationUnitsQueryCgResponse['organizationUnits'][number];

export type OrganizationUnitScope = 'default' | 'organization' | 'department';

export type ActiveChildEntities = {
  id: string;
};

export const WORKS_ORGANIZATION_UNITS_QUERY: TypedDocumentNode<
  WorksOrganizationUnitsQueryCgResponse,
  WorksOrganizationUnitsQueryVariables
> = gql`
  query OrganizationUnitsQuery {
    organizationUnits(input: { scope: "organization" }) {
      id
      name
      costCenter
    }
  }
`;
